import { Event } from '@livecontrol/scheduler/model';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import type { ScheduledEvent } from './type';
import type { UseEventsHook } from './use-events';
import { useEvents } from './use-events';

import Phase = Event.Phase;

type SortBy = Parameters<UseEventsHook>[0]['sortBy'];

const compareBy = (sortBy: SortBy, a: ScheduledEvent, b: ScheduledEvent): number => {
  switch (sortBy) {
    case 'eid':
      return Number(a.eid) - Number(b.eid);
    case 'cid':
      return Number(a.client?.cid ?? 0) - Number(b.client?.cid ?? 0);
    case 'organizationName':
      return (a.client?.organizationName ?? '').localeCompare(b.client?.organizationName ?? '');
    default:
      return String(a.startTime ?? '').localeCompare(String(b.startTime ?? ''));
  }
};

export const usePastEvents: UseEventsHook = (filters) => {
  const results = useEvents(filters, { status: Phase.Past });

  const { sortBy, sortOrder } = filters;

  const events = useMemo(() => {
    const direction = sortOrder === 'DESC' ? -1 : 1;

    return results.events
      ?.filter((v) => DateTime.fromISO(v.startTime) < DateTime.now() && !v.isLive)
      .sort((a, b) => direction * compareBy(sortBy, a, b));
  }, [results.events, sortBy, sortOrder]);

  return { ...results, events };
};
